export default {"src":"/_next/static/media/satisfaction-user-neutral-icon.c7fdb7f9.svg","height":15,"width":14};